import { Component, Input, OnInit } from "@angular/core";
import { MapService } from "src/app/features/shared/services/Map.service";
import { MapHelperService } from "src/services/map-helper.service";
@Component({
  selector: "map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.css"],
})
export class MapComponent implements OnInit {
  @Input() $Items: any = [];
  
  constructor(private map: MapService, 
    private mapHelper: MapHelperService) {}

  ngOnInit() {
  }

  
  

 
}
